/**
 * react-select options expose `isDisabled` for choices a person cannot pick.
 * Operator must treat those the same way — they are not valid select-tool targets.
 *
 * @param option - A dropdown option of unknown shape.
 * @returns Whether the option is marked disabled.
 */
export const isSelectOptionDisabled = (option: unknown): boolean => {
  if (option == null || typeof option !== "object") {
    return false;
  }
  return Boolean((option as { isDisabled?: boolean }).isDisabled);
};
